import React from "react";
import { Table } from "react-bootstrap";
import { withNamespaces } from "react-i18next";

const ExportTable = ({
  componentRef,
  calendarData,
  selectedGroup,
  gruposTrabalhoRemoto,
  loadNewDateSelected,
  tableType,
  t,
}) => {
  return (
    <div style={{ display: "none" }}>
      <div ref={componentRef}>
        {/* Legend */}
        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h4>{t("portalrh.workDays.legendTitle")}</h4>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div>
                <span
                  style={{
                    backgroundColor: "#E2E2E2",
                    padding: "5px",
                    marginRight: "10px",
                  }}
                ></span>
                {t("portalrh.workDays.feriasTranslated.folgasFeriados")}
              </div>
              <div>
                <span
                  style={{
                    backgroundColor: "#188804",
                    padding: "5px",
                    marginRight: "10px",
                  }}
                ></span>
                {t("portalrh.workDays.feriasTranslated.approved")}
              </div>
              <div>
                <span
                  style={{
                    backgroundColor: "#C9FFCC",
                    padding: "5px",
                    marginRight: "10px",
                  }}
                ></span>
                {t("portalrh.workDays.feriasTranslated.gozadas")}
              </div>
              {tableType && (
                <div>
                  <span
                    style={{
                      backgroundColor: "goldenrod",
                      padding: "5px",
                      marginRight: "10px",
                    }}
                  ></span>
                  {t("portalrh.workDays.feriasTranslated.pending")}
                </div>
              )}
            </div>
          </div>
          <div>
            <h4>{`${t(
              "portalrh.workDays.vacationsPlanOf"
            )} ${loadNewDateSelected.getFullYear()}`}</h4>
            <div>
              <strong>{t("portalrh.workDays.group")}</strong>{" "}
              {selectedGroup.length === 1
                ? gruposTrabalhoRemoto.find(
                    (group) => group.grupo.id === selectedGroup[0]
                  ).grupo.designacao
                : `${selectedGroup.length} ${t(
                    "portalrh.workDays.selectedGroups"
                  )}`}
            </div>
          </div>
        </div>

        {calendarData.map((monthData, index) => (
          <div
            key={index}
            style={{
              border: "1px solid black",
              padding: "10px",
              marginBottom: "20px",
            }}
          >
            <h3 style={{ textAlign: "center" }}>{monthData.month}</h3>
            <Table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  {Array.from(
                    { length: monthData.days[0].days.length },
                    (_, day) => (
                      <th key={day} style={{ width: "15px", padding: "2px" }}>
                        {day + 1}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {monthData.days.map((person, index) => (
                  <tr key={index}>
                    <td style={{ padding: "2px" }}>{person.name}</td>
                    {person.days.map((day, dayIndex) => (
                      <td
                        key={dayIndex}
                        style={{
                          backgroundColor:
                            day.isDayOff || day.isHoliday
                              ? "#E2E2E2"
                              : day.isVacationApproved
                              ? "#188804"
                              : day.isVacationGozado
                              ? "#C9FFCC"
                              : day.isVacationsPending
                              ? "goldenrod"
                              : "white",
                          width: "15px",
                          padding: "2px",
                        }}
                      >
                        {/* No text, just color */}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ))}

        {/* Signature and Date */}
        <div
          style={{
            marginTop: "50px",
            paddingTop: "10px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          <div>
            <strong>{t("portalrh.workDays.assinature")}</strong>
            <span>___________________________</span>
          </div>
          <div>
            <strong>{t("portalrh.workDays.date")}</strong>
            <span>___________________________</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(ExportTable);
